import Cookies from 'js-cookie'

const UserInfoKey = 'cg_app_userinfo'

export function getUserInfo() {
  let userInfo = Cookies.get(UserInfoKey);

  try {
    return JSON.parse(userInfo);
  } catch (error) {
    return {
      token: ''
    };
  }
}

export function setUserInfo(userInfo = {}) {
  return Cookies.set(UserInfoKey, userInfo);
}

export function removeUserInfo() {
  return Cookies.remove(UserInfoKey)
}
